import { Icon } from "@chakra-ui/icons"
import React from "react"

const YouTubeIcon = props => {
  return (
    <Icon viewBox="0 0 31.5 31.5" {...props}>
      <g>
        <path
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="M.75.75h30v30h-30z"
        />
        <path
          d="M23.21 10.61c-.3-.27-.58-.44-1.72-.55-1.43-.13-3.37-.15-4.84-.15h-1.81c-1.46 0-3.4 0-4.83.15-1.14.11-1.43.28-1.73.55-.79.72-1 2.69-1 4.62v1.08c0 1.92.2 3.86 1 4.57.3.28.59.45 1.73.55 1.43.14 3.37.15 4.83.16h1.81c1.47 0 3.41 0 4.84-.16 1.14-.1 1.42-.27 1.72-.55.78-.7 1-2.61 1-4.52v-1.23c-.04-1.9-.21-3.81-1-4.52zm-9.12 7.72v-5l4.27 2.43z"
          fill="currentColor"
        />
      </g>
    </Icon>
  )
}

export default YouTubeIcon
